import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

class LeadTimesClient {
  static baseUrl = BASE_URL;

  static getLeadTimes() {
    const url = `${this.baseUrl}/nsc/leadtimes`;

    return axios
      .get(url, getHeaders())
      .then((response) =>
        response &&
        response.data &&
        response.data.result &&
        response.data.result.leadTimes
          ? Object.values(response.data.result.leadTimes)
          : []
      )
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
  static postLeadTimes(leadTimes) {
    const url = `${this.baseUrl}/nsc/leadtimes`;

    return axios
      .post(url, leadTimes, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default LeadTimesClient;
